import { render } from "./AddSubcategoryModal.vue?vue&type=template&id=650d609c"
import script from "./AddSubcategoryModal.vue?vue&type=script&lang=js"
export * from "./AddSubcategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__